import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  OfferAcceptDocumentResponse,
  OfferAcceptState,
} from "./offerAcceptInterfaces";

import { generatePdfFromBase64EncodedString } from "Utils/fileDownload/fileDownloadUtils";

const initialState: OfferAcceptState = {
  fileUrl: undefined,
  isUpdating: false,
  updated: false,
  error: null,
};

const offerAcceptSlice = createSlice({
  name: "offerAccept",
  initialState,
  reducers: {
    getOfferDocumentFailed: (state, action: PayloadAction<string>) => {
      state.error = action.payload?.toString();
      state.isUpdating = false;
    },

    getOfferDocument: (state) => {
      state.isUpdating = true;
    },

    getOfferDocumentSucceeded: (
      state,
      action: PayloadAction<OfferAcceptDocumentResponse>,
    ) => {
      state.fileUrl = generatePdfFromBase64EncodedString(
        action.payload.pdf.bytes,
      );
      state.isUpdating = false;
      state.updated = true;
      state.error = null;
    },
  },
});

export const {
  getOfferDocument,
  getOfferDocumentFailed,
  getOfferDocumentSucceeded,
} = offerAcceptSlice.actions;

export const offerAccept = offerAcceptSlice.reducer;
